export default __webpack_public_path__ + "static/4-ec6fca35e9faccc41aa533d79fe20c4e.jpeg";